import { COLORS } from '@btime/constants'
import { capitalizeAllIfLower } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import { SmallText, Text, Title } from '../../../../components/presentation/Text'
import { UserAvatar } from '../../../../components/presentation/Avatar'
import { useLoggedUser, useLogout } from '@btime/react-session'
import Container from '../../../../components/structure/Container'
import FlexGrid from '../../../../components/structure/FlexGrid'
import Link from '../../../../components/actions/Link'
import Separator from '../../../../components/helpers/Separator'

const LoggedProfilePageContent = () => {
  const user = useLoggedUser()

  const logout = useLogout()
  const { t } = useTranslation('profiles')

  return (
    <Fragment>
      <Container>
        <FlexGrid direction="column" align="center" justify="center">
          <Separator weight={8} />

          <UserAvatar size="xlarge" user={user} />
          <Separator weight={5} />
          <Title size="h3" align="center" noMargin>
            {capitalizeAllIfLower(user.name)}
          </Title>

          <SmallText align="center">{user.email}</SmallText>

          <Separator weight={8} />

          <Link onClick={logout}>
            <Text color={COLORS.red}>{t('logout')}</Text>
          </Link>
        </FlexGrid>
      </Container>
    </Fragment>
  )
}

export default LoggedProfilePageContent
